import React from 'react'
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer'

const PAGE_TITLES = {
    1: 'Questionnaire 1 — Camera Setup',
    3: 'Questionnaire 2 — Shooting',
    5: 'Questionnaire 3 — Loading',
}

const PAGE_QUESTIONS = {
    1: [
        'Write your full name here.',
        'What camera and lens do you have?',
        'Can you check the date/time on your camera now and write it in here including AM/PM.',
        'What setting is your photo quality on?',
        'When you tested a photo what size was it?',
        'How many batteries do you have?',
    ],
    3: [
        'What burst setting should you use?',
        'How many photos of each competitor are we expecting?',
        'What editing software do we want you to use?',
    ],
    5: [
        'Go to www.speedtest.net and test your wifi speed. What is the upload and download speed?',
        'What is your backup plan if your Wifi or Computer fails?',
        'Login to https://www.bossfotos.com/photographer/map . What is the name of one of your galleries or the latest gallery?',
        'How do you delete a gallery?',
        'When should you start and finish loading the photos to Bossfotos?',
        'What and who do you inform when you start loading a gallery?',
        'Which browser should you use?',
    ],
}

export const GuideAnswersPdf = ({ allAnswers }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <Text style={styles.title}>Documentation Guide — Answers</Text>

            {Object.keys(PAGE_QUESTIONS).map((pageIndex) => {
                const questions = PAGE_QUESTIONS[pageIndex]
                const answers = allAnswers[pageIndex] || {}
                const sectionTitle = PAGE_TITLES[pageIndex]

                return (
                    <View key={pageIndex} style={styles.section}>
                        <Text style={styles.sectionTitle}>{sectionTitle}</Text>
                        {questions.map((question, i) => (
                            <View key={i} style={styles.questionBlock}>
                                <Text style={styles.question}>{i + 1}) {question}</Text>
                                <Text style={styles.answer}>{answers[i] || '(no answer)'}</Text>
                            </View>
                        ))}
                    </View>
                )
            })}
        </Page>
    </Document>
)

const styles = StyleSheet.create({
    page: {
        padding: 40,
        fontSize: 11,
        fontFamily: 'Helvetica',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 20,
    },
    section: {
        marginBottom: 16,
    },
    sectionTitle: {
        fontSize: 13,
        fontWeight: 'bold',
        marginBottom: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#ccc',
        paddingBottom: 4,
    },
    questionBlock: {
        marginBottom: 8,
    },
    question: {
        fontWeight: 'bold',
        marginBottom: 2,
    },
    answer: {
        color: '#333',
        paddingLeft: 12,
    },
})
